import React from 'react';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { Seo } from '@shared/components/Seo';
import { useTranslation } from '@shared/core';
import { getNamedCategoryPathFromStationeryTemplateCategory } from '@apps/card/Card.routes';
import { StationerySchema } from './components/StationerySchema';
import { FaqItem } from '@apps/card/routes/PublicShop/components/FaqSection/useStationeryFaqItems';

type GallerySeoProps = Readonly<{
  currentCategory: StationeryTemplateCategoryEnum;
  faqItems: ReadonlyArray<FaqItem>;
  isPublicShopRoute: boolean;
}>;

export const GallerySeo = ({ currentCategory, faqItems, isPublicShopRoute }: GallerySeoProps) => {
  const { t } = useTranslation('stationery');
  const tPublicShopMeta = t('publicShop', 'meta');

  let title = tPublicShopMeta.fallback.title();
  let description = '';
  let image = '';

  const canonicalURL = `https://withjoy.com/cards/wedding/${getNamedCategoryPathFromStationeryTemplateCategory(currentCategory)}/`;

  if (currentCategory === StationeryTemplateCategoryEnum.saveTheDate) {
    title = tPublicShopMeta.saveTheDate.title();
    description = tPublicShopMeta.saveTheDate.description();
    image = 'https://withjoy.com/assets/public/stationery-og-save-the-date-2.png';
  }

  if (currentCategory === StationeryTemplateCategoryEnum.invitation) {
    title = tPublicShopMeta.invitation.title();
    description = tPublicShopMeta.invitation.description();
    image = 'https://withjoy.com/assets/public/stationery-og-invitations.png';
  }

  return (
    <>
      <Seo
        title={title}
        description={description}
        ogImage={image}
        canonicalURL={canonicalURL}
      />
      {isPublicShopRoute && (
        <StationerySchema
          category={currentCategory}
          title={title}
          description={description}
          canonicalURL={canonicalURL}
          faqItems={faqItems}
        />
      )}
    </>
  );
};
